import { Controller } from "@hotwired/stimulus"

let pendingFocus = null

export default class extends Controller {
  connect() {
    if (!pendingFocus) return

    const focusState = pendingFocus
    pendingFocus = null

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        const field = this.findField(focusState.name)
        if (!field) return

        field.focus()

        if (focusState.selectionStart == null || typeof field.setSelectionRange !== "function") return

        field.setSelectionRange(focusState.selectionStart, focusState.selectionEnd)
      })
    })
  }

  submit(event) {
    this.storeFocus(event)

    if (this.element.requestSubmit) {
      this.element.requestSubmit()
    } else {
      this.element.submit()
    }
  }

  storeFocus(event) {
    const field = event?.target
    if (!(field instanceof HTMLElement)) return
    if (!field.name) return

    pendingFocus = {
      name: field.name,
      selectionStart: typeof field.selectionStart === "number" ? field.selectionStart : null,
      selectionEnd: typeof field.selectionEnd === "number" ? field.selectionEnd : null
    }
  }

  findField(name) {
    const fields = Array.from(this.element.elements).filter((field) => {
      return field instanceof HTMLElement && field.name === name
    })

    return fields.find((field) => this.isVisible(field)) || fields[0] || null
  }

  isVisible(field) {
    if (field.closest(".tw-hidden")) return false

    return field.offsetWidth > 0 || field.offsetHeight > 0 || field.getClientRects().length > 0
  }
}
